import React from 'react';

import {Icon, Gift, GlassesSparkle} from '@optimaxdev/icons';

import {GiftFreeGlassesPopup} from '../giftFreeGlassesPopup/giftFreeGlassesPopup';
import {GiftPopup} from '../giftPopup/giftPopup';

import s from './cartGiftBanner.scss';

type PropsType = {
    giftType: 'vistaPlus' | 'freeGlasses';
};

const CONTENT = {
    freeGlasses: {
        icon: (
            <div className={s.glassesIconWrapper}>
                <Icon className={s.glassesIcon} icon={GlassesSparkle} strokeWidth={3} />
            </div>
        ),
        subtitle: (
            <>
                Get FREE glasses worth up to $150 with your first shipment (prescription
                included).&nbsp;
                <GiftFreeGlassesPopup />
            </>
        ),
        title: 'Surprise! FREE glasses included with your first order.',
    },
    vistaPlus: {
        icon: (
            <div className={s.giftIconWrapper}>
                <Icon className={s.giftIcon} icon={Gift} strokeWidth={3} />
            </div>
        ),
        subtitle: (
            <>
                We&apos;re treating you to a 10-day sample package. We&apos;ll verify the details
                you entered with your doctor.&nbsp;
                <GiftPopup />
            </>
        ),
        title: 'Surprise! Vista Plus contacts are included with your order.',
    },
};

/**
 * Vista PLus trial product cart page banner
 * @returns {React.ReactElement} - rendered component
 */
export const CartGiftBanner: React.FC<PropsType> = ({giftType}) => {
    const {icon, subtitle, title} = CONTENT[giftType];

    return (
        <section className={s.container}>
            {icon}
            <div className={s.text}>
                <p className={s.title}>{title}</p>
                <p className={s.subtitle}>{subtitle}</p>
            </div>
        </section>
    );
};
